import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

const NOTE = { booked: " — confirmed booking", held: " — tentative hold", past: " — passed" };

export const MoveForm = ({ b, onDone }) => {
  const [day, setDay] = useState(b.preferred_date);
  const [slot, setSlot] = useState("");
  const [notify, setNotify] = useState(true);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const qc = useQueryClient();
  const { data: slots } = useQuery({ queryKey: ["slots", day], queryFn: async () => (await api.get("/slots", { params: { day } })).data, enabled: !!day });
  const isCurrent = (t) => day === b.preferred_date && t === b.time_slot;

  const save = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post(`/admin/bookings/${b.id}/move`, { preferred_date: day, time_slot: slot, notify, message });
      toast.success(notify ? "Booking moved — client emailed" : "Booking moved");
      qc.invalidateQueries({ queryKey: ["admin"] });
      qc.invalidateQueries({ queryKey: ["slots"] });
      onDone(day);
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };

  return (
    <form className="cal-move" onSubmit={save} data-testid="move-form">
      <div className="cal-move-grid">
        <label>New date<input type="date" required value={day} onChange={(e) => { setDay(e.target.value); setSlot(""); }} data-testid="move-date-input" /></label>
        <label>New time
          <select required value={slot} onChange={(e) => setSlot(e.target.value)} data-testid="move-time-select">
            <option value="">Choose a time</option>
            {(slots || []).map((s) => (
              <option key={s.time} value={s.time} disabled={s.status === "past" || s.status === "booked" || isCurrent(s.time)}>
                {`${s.label}${isCurrent(s.time) ? " — current" : NOTE[s.status] || ""}`}
              </option>
            ))}
          </select>
        </label>
      </div>
      <label className="ad-check"><input type="checkbox" checked={notify} onChange={(e) => setNotify(e.target.checked)} data-testid="move-notify-checkbox" /> Email {b.name.split(" ")[0]} about the new time</label>
      {notify && <textarea rows={2} maxLength={600} placeholder="Optional note for the client (e.g. sorry for the change!)" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="move-message-input" />}
      <div className="req-actions">
        <button className="btn gold" type="submit" disabled={busy || !slot} data-testid="move-save-button">{busy ? <Loader2 size={15} className="spin" /> : "Move booking"}</button>
        <button className="btn light" type="button" onClick={() => onDone()} data-testid="move-cancel-button">Cancel</button>
      </div>
    </form>
  );
};
